// Copyright (c) 2016 Deere & Company

import LaborAdditiveSummaries from '../state/labor-additive-summaries';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateLaborAdditiveSummaries = (state, action) =>
    LaborAdditiveSummaries.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().laborAdditiveSummaries, action) => {

    const actionTypes = {
        [actions.READ_LABOR_ADDITIVE_PIP_PRODUCTS_SUMMARIES_SUCCESS]: updateLaborAdditiveSummaries
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/labor-additive/reducers/labor-additive-summaries.js